<!--
  Program: Top menu
  Author: SDL
  Brief: top menu common layout
-->
<template>
  <header class="header_wrap">
    <nav class="nav_wrap">
      <div class="sys_title">
        <router-link :to="{ name: 'mainIndexPage' }" href="javascript:">
          <h1 />
        </router-link>
        <a href="javascript:void(0)" class="ico_alram" @click="toggleNoticeArea()">
          <span class="badge badge-danger" v-if="newNoticeCount > 0">{{ newNoticeCount }}</span>
        </a>
        <!--공지사항-->
        <div class="gnb_notice" v-show="showNoticeArea" v-click-outside="closeNotice">
          <h5>
            {{ $t('sdl.main.message.notice') }}
            <span>{{ $t('sdl.common.label.total') }} <strong>{{ noticeList.length }}</strong></span>
            <button type="button" class="close" @click="toggleNoticeArea()"><i class="material-icons">close</i></button>
          </h5>
          <div class="gnb_notice_row">
            <div class="gnb_notice_list">
              <a
                href="javascript:void(0)"
                v-for="notice in noticeList"
                :key="notice.postId"
                :class="{ active: selectedNotice.postId === notice.postId, notread: !notice.noticeChecked }"
                @click="selectNotice(notice)"
              >
                {{ notice.postTitle }}
              </a>
            </div>
            <div class="gnb_notice_contents">
              <div class="gnb_in_board" v-html="$options.filters.nl2br(selectedNotice.postDetail)"></div>
              <p v-for="file in imageAttachments" :key="file.fileId">
                  <img :ref="file.fileId" />
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- menu -->
      <div class="gnb_menu">
        <ul>
          <li v-for="menu in rootMenus" :key="menu.menuId" :index="menu.menuId" :class="{ 'current': setCurrentMenuStyle(menu) }">
            <a
              @click="moveTopMenu(menu);"
            >
              {{ getLabel(menu) }}
            </a>
          </li>
        </ul>
      </div>
      <!-- right menu -->
      <div class="fnc_wrap">
        <span class="division">{{ selectedDivisionLabel }}<button class="btn ico_search fnc_division" type="button" @click="changeOffsider('division')" v-if="isAdmin"></button> </span>
        <a class="fnc_user" @click="changeOffsider('user')" :title="$t('sdl.privacyPolicy.userInfo')"></a>
        <a class="fnc_manual" @click="openUserManual" :title="$t('cop.common.main-manual')"></a>
        <a class="fnc_bookmark" @click="(quickSubmenu = false), changeOffsider('quick')" :title="$t('sdl.myMenu.label.favorite.title')"></a>
        <a class="fnc_alram notice_popup_alarm" @click="toggleNoticeArea()" :title="$t('sdl.main.message.notice')">
          <em class="notice_popup_alarm" v-if="newNoticeCount > 0">{{ newNoticeCount }}</em>
        </a>
      </div>
    </nav>
    <!-- user 사용자 -->
    <div class="user_info_wrap" v-show="offsider === 'user' || offsider === 'language' || offsider === 'timezone'" v-click-outside="closeUser">
      <a class="ico_pop_close" title="Close Setting" @click="changeOffsider('user')">close</a>
      <p class="email">{{ userInfo.email }}</p>
      <p class="user">
        <span class="name">{{ userInfo.language === 'en_US' && userInfo.userNameEn ? userInfo.userNameEn : userInfo.userName }}</span>
        <span>{{ userInfo.language === 'en_US' && userInfo.deptNameEn ? userInfo.deptNameEn : userInfo.deptName}} / {{ userInfo.language === 'en_US' && userInfo.compNameEn ? userInfo.compNameEn : userInfo.compName }}</span>
      </p>
      <select v-model="userDivisionInfo.divisionCode" @change="changeUserDivision(userDivisionInfo.divisionCode)">
        <option v-for="division in userDivisionList" :key="division.divisionCode" :value="division.divisionCode">{{ division.label }}</option>
      </select>
      <select
        required=""
        v-model="timeZoneArea"
        @change="timeZoneId = ''"
      >
        <option value="Africa">{{ $t('sdl.common.timezone.Africa') }}</option>
        <option value="America">{{ $t('sdl.common.timezone.America') }}</option>
        <option value="Asia">{{ $t('sdl.common.timezone.Asia') }}</option>
        <option value="Atlantic">{{ $t('sdl.common.timezone.Atlantic') }}</option>
        <option value="Australia">{{ $t('sdl.common.timezone.Australia') }}</option>
        <option value="Europe">{{ $t('sdl.common.timezone.Europe') }}</option>
        <option value="Indian">{{ $t('sdl.common.timezone.Indian') }}</option>
        <option value="Pacific">{{ $t('sdl.common.timezone.Pacific') }}</option>
        <option value="Etc">{{ $t('sdl.common.timezone.Etc') }}</option>
      </select>
      <select required="" v-model="timeZoneId" @change="saveTimezone()" :title="timezoneDisplayName">
        <option value="" disabled>{{ $t('sdl.offsider.label.select') }}</option>
        <option :value="time.timeZoneId" v-for="time in filteredTimeZoneList" :key="time.timeZoneId">
          {{ time.displayTimeZone }}
        </option>
      </select>
      <!-- <select @change="changeLocale($event.target.value)" v-model="userInfo.language">
        <option v-for="locale in availableLocales" :key="locale" :data-locale="locale" :value="locale">{{ getLocaleLabel(locale) }}</option>
      </select> -->
      <button class="btn btn-secondary" @click="goLoginPage">Logout</button>
    </div>
    <!-- // user -->

    <!-- Bookmark -->
    <div v-show="offsider === 'quick'" class="bookmark_wrap" v-click-outside="closeBookmark">
      <!-- book_mark_list -->
      <div class="bookmark_list">
        <div class="com_head">
          <h4>{{ $t('sdl.myMenu.label.favorite.title') }} ({{ userMenusStore.length }}/{{ filteredQuickMenus.length }}) </h4>
          <div class="button">
            <a class="ico_pop_setting" title="Open Settings" @click="quickSubmenu = !quickSubmenu">setting</a>
            <!-- 설정버튼 클릭시 .ui--aside-quick .setting 이 부분이 display:block 되면 됩니다. -->
            <a class="ico_pop_close" title="Close Setting" @click="(quickSubmenu = false), changeOffsider('quick')">close</a>
          </div>
        </div>
        <h4 v-if="userMenusStore.length === 0" class="tc">{{ $t('sdl.common.message.noResult') }}</h4>
        <draggable
          v-model="userMenusStore"
          tag="ul"
          v-bind="dragOptions"
          @change="moveMenuList"
          handle=".drag-handle"
        >
          <li v-for="(menu, index) in userMenusStore" :key="menu.menuId">
            <a
              :href="menu.externalUrl.startsWith('http') ? menu.externalUrl : `http://${menu.externalUrl}`"
              v-if="menu.externalUrlUsed"
              target="_blank"
            >
              <i
                title="Move Menu"
                class="material-icons ui--icon-xs drag-handle"
                v-show="quickSubmenu"
                style="cursor: move"
              >
                drag_indicator
              </i>
              {{ getLabel(menu) }} <i class="material-icons menu-icon-2">open_in_new</i>
            </a>
            <router-link :to="menu.pagePath" v-else>
              <i
                title="Move Menu"
                class="material-icons ui--icon-xs drag-handle"
                v-show="quickSubmenu"
                style="cursor: move"
              >
                drag_indicator
              </i>
              {{ getLabel(menu) }}
            </router-link>

            <button
              class="btn btn_icon ico_mynus"
              :title="$t('sdl.common.label.delete')"
              @click="removeQuickMenu(menu.menuId, index)"
              v-show="quickSubmenu"
            >
            </button>
          </li>
        </draggable>
      </div>
      <!-- book_mark_setting -->
      <div class="bookmark_setting" v-show="quickSubmenu">
        <div class="com_head">
          <h4>All Menu</h4>
          <div class="button">
            <a class="ico_pop_close" title="Close Setting" @click="(quickSubmenu = false), (searchQuickMenu = '')">close</a>
          </div>
        </div>
        <div class="com_head">
          <div class="fx_form">
            <input
              type="text"
              :placeholder="$t('sdl.offsider.label.searchMenu')"
              autocomplete="on"
              v-model="searchQuickMenu"
              @input="searchQuickMenu = $event.target.value"
              @keyup.esc="searchQuickMenu = ''"
            />
          </div>
        </div>
        <ul>
          <li v-for="menu in filteredQuickMenus" :key="menu.menuId" :class="{ selected: menu.selected }">
            <a href="javascript:">
              {{ getLabel(menu) }}
              <i class="material-icons menu-icon-2" v-show="menu.externalUrlUsed">open_in_new</i>
            </a>
            <button class="btn btn_icon ico_plus" :title="$t('sdl.common.label.add')" @click="addQuickMenu(menu)"></button>
          </li>
        </ul>
      </div>
    </div>
    <!-- // Bookmark -->

    <!-- Division -->
    <div class="division_info_wrap" v-show="offsider === 'division'" v-click-outside="closeDivision">
      <a class="ico_pop_close" title="Close" @click="changeOffsider('division')">close</a>
      <div class="fx_form_wrap">
        <div class="form_row">
          <div class="form_item">
            <label>{{ $t('cop.std.prj.division.lable.region') }}</label>
            <CodeSelect
              :all="false"
              :codeCondition="{ commCodeTypeId: 'DOMESTIC' }"
              select
              v-model="domesticInfo"
              @change="onChangeDomestic()"
            />
          </div>
        </div>
        <div class="form_row">
          <div class="form_item">
            <label>{{ $t('cop.std.prj.division.lable.divReq') }}</label>
            <select v-model="divRhq" @change="onChangeGbM()" :disabled="!domesticInfo">
              <option value="">{{ $t('sdl.common.label.select') }}</option>
              <option v-for="(item, index) in divRhqList" :key="index" :value="item.divisionCd">
                {{ item.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="form_row">
          <div class="form_item">
            <label>{{ $t('cop.std.prj.division.lable.gbmSub') }}</label>
            <select
              v-model="gbmSub"
              :disabled="(!domesticInfo, !divRhq)"
              @change="changeAdminUserDivision(gbmSub)"
            >
              <option value="">{{ $t('sdl.common.label.select') }}</option>
              <option v-for="(item, index) in gbmSubList" :key="index" :value="item.divisionCd">
                {{ item.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <!-- // Division -->

    <OnBoarding ref="onBoarding" />
  </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import axios from 'axios';
import draggable from 'vuedraggable';
import moment from 'moment';
import store from '@/vuex/store';
import SDLLocale from '@/mixin/SDLLocale';
import RouterCommon from '@/mixin/RouterCommon';
import { SDLUtil, StringUtil } from '@/utils';
import loginService from '@/service/loginService';
import EntrustApprovalPopup from '@/components/common/popup/EntrustApprovalPopup';
import ChangePasswordPopup from '@/components/common/popup/ChangePasswordPopup';
import OnBoarding from '@/components/view/admin/main/OnBoarding';
import CodeSelect from '@/components/common/code/CodeSelect.vue';

export default {
  name: 'TopMenu',
  components: {
    draggable,
    OnBoarding,
    CodeSelect,
  },
  mixins: [SDLLocale, RouterCommon],
  data() {
    return {
      showNoticeArea: false,
      noticeList: [],
      readNoticeList: [],
      selectedNotice: {},
      subMenuLimitCnt: 2,
      clickedMenuId: '',
      divisionCodeList: [],

      // from 우측 사이드바
      userInfo: null,
      offsider: '',
      quickSubmenu: false,
      searchQuickMenu: '',
      quickMenus: [],
      userMenus: [],
      timeZoneList: [],
      timeZoneArea: '',
      timeZoneId: '',
      timeZoneAreaList: ['Africa', 'America', 'Asia', 'Atlantic', 'Australia', 'Europe', 'Indian', 'Pacific'], // etc 제외
      dragOptions: {
        animation: 200,
        group: 'quickList',
        disabled: false,
        ghostClass: 'ghost',
      },
      post: {},
      imageAttachments: [],
      clickOutsideExcludeElements: [], // clickOutside() 제외할 element 리스트

      domesticInfo: null, // Region
      divRhqList: [], // Division /RHQ 리스트
      gbmSubList: [], // GBM/Sub. 리스트
      divRhq: '', // 선택된 Division /RHQ
      gbmSub: '', // 선택된 GBM/Sub
    };
  },
  props: {
    fixTop: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      menus: 'getMenus', // Receive menus with getter
      userMenusStore: 'getUserMenusBreadCrumb',
      userDivisionInfo: 'getUserDivisionInfo',
      userDivisionList: 'getUserDivisionList',
      divisionInfo: 'getDivisionInfo',
      mainPath: 'getMainPath',
      currentRoleList: 'getSelectRole',
    }),
    rootMenus() {
      return _.sortBy(this.menus.filter(menu => menu.menuLevel === 1 && menu.menuId !== 'COMM_URL'), ['menuSequence']);
    },
    newNoticeCount() {
      return this.noticeList.filter(notice => !notice.noticeChecked).length;
    },
    currentMenu() {
      if (this.$route.meta.menuId) return _.find(this.menus, ['menuId', this.$route.meta.menuId]);
      return _.find(this.menus, ['label', 'Access Key Summary']);
    },
    superParentMenu() {
      let parentMenu = this.menus.find(item => item.menuId === this.currentMenu.parentId);
      while (parentMenu.menuLevel > 1) {
        const menuId = parentMenu.parentId;
        parentMenu = this.menus.find(item => item.menuId === menuId);
      }
      return parentMenu;
    },
    selectedDivisionLabel() {
      const selectedDivision = _.find(this.divisionCodeList, { divisionCd: this.userDivisionInfo.divisionCode });
      return _.isEmpty(selectedDivision) ? '' : selectedDivision.label;
    },
    // from 우측 사이드바 시작
    userTimezoneLabel() {
      if (this.userInfo) if (this.userInfo.timeZoneId && this.userInfo.timeZoneCode) return `${this.userInfo.timeZoneId} (${this.userInfo.timeZoneCode})`;
      return '';
    },
    filteredTimeZoneList() {
      const getGmt = (str) => Number(str.substring(str.indexOf('GMT') + 3, str.indexOf(':')));
      if (this.timeZoneArea === 'Etc') {
        return _.sortBy(this.timeZoneList.filter(zone => !this.timeZoneAreaList.includes(zone.timeZoneArea)), [(obj) => getGmt(obj.displayTimeZone), 'displayTimeZone']);
      }
      return _.sortBy(this.timeZoneList.filter(zone => zone.timeZoneArea === this.timeZoneArea), [(obj) => getGmt(obj.displayTimeZone), 'displayTimeZone']);
    },
    siteMapRows() {
      return Math.ceil(this.rootMenus.length / 4);
    },
    lastUserName() {
      return this.userInfo.userName && this.userInfo.userName.toUpperCase().split('')[0];
    },
    filteredQuickMenus() {
      return _.orderBy(
        this.quickMenus.filter(menu => {
          menu.curLabel = this.getLabel(menu);
          return this.getLabel(menu)
            .toUpperCase()
            .includes(this.searchQuickMenu.toUpperCase());
        }),
        'curLabel',
        'asc',
      );
    },
    availableLocales() {
      return this.$i18n.availableLocales;
    },
    timezoneDisplayName() {
      const selectedTimezone = _.find(this.timeZoneList, { timeZoneId: this.timeZoneId });
      if (selectedTimezone) return selectedTimezone.displayTimeZone;
      return null;
    },
    isAdmin() {
      return _.includes(this.currentRoleList, 'SYSTEM_ADMIN') || _.includes(this.currentRoleList, 'Companmy_Admin');
    },
  },
  watch: {
    $route() {
      this.showNoticeArea = false;
      this.getNoticeList().then(() => { this.showNotCheckedNotice(); });
      this.init(); // from 우측 사이드바
    },
    fixTop() {
      this.toggleGnbMenuDepth();
    },
    // from 우측 사이드바 시작
    userTimezoneLabel() {
      this.setGMT(this.userInfo.timeZoneId);
      moment.tz.setDefault(this.userInfo.timeZoneId);
    },
    // from 우측 사이드바 끝
  },
  methods: {
    getSuperParentMenu(menu) {
      if (menu.menuLevel > 0) {
        let parentMenu = _.find(this.menus, { menuId: menu.parentId });
        if (_.isEmpty(parentMenu)) return;
        while (parentMenu.menuLevel > 1) {
          const menuId = parentMenu.parentId;
          parentMenu = _.find(this.menus, { menuId });
          if (_.isEmpty(parentMenu)) return;
        }
        return parentMenu;
      }
    },
    setSubMenuStyle() {
      // Use setTimeout to process after ui rendering
      setTimeout(() => {
        const cssSelector = 'header > nav > ul > li.nav-item.dropdown.show';
        const openMenu = document.querySelector(cssSelector);
        // console.info('openMenu', openMenu);
        if (openMenu && !openMenu.querySelector('.text-center')) {
          const marginLeft = 12;
          const ulMarginLeft = openMenu.offsetLeft + marginLeft;
          document
            .querySelector(`${cssSelector} ul.dropdown-item`)
            .setAttribute('style', `margin-left: ${ulMarginLeft}px`);
        }
      });
    },
    getSubmenu(parentId) {
      return _.sortBy(this.menus.filter(menu => menu.parentId === parentId), ['menuSequence']);
    },
    moveMenu(pagePath) {
      // Initialize saved parameters when forced to move from the menu
      store.commit('PARAMS', {});
      this.handleRouterPush(pagePath);
      // If the moving component is the same, refresh is required
      const fromComponentName = this.$route.meta.componentName;
      const toMenu = _.find(this.menus, ['menuUrl', pagePath]);
      if (fromComponentName === toMenu.componentName) {
        this.$emit('router-reload');
      }
    },
    async moveTopMenu(topMenu) {
      const recursiveMenuUrl = await this.recursiveMenuFind(topMenu);
      if (recursiveMenuUrl) {
        this.moveMenu(recursiveMenuUrl);
      }
    },
    recursiveMenuFind(menu) {
      const firstMenu = this.getSubmenu(menu.menuId)[0];
      if (!firstMenu.menuUrl || firstMenu.menuUrl === '/emptypage') return this.recursiveMenuFind(firstMenu);
      return firstMenu.menuUrl;
    },
    openExternalUrl(isExternal, url, event) {
      if (isExternal) {
        window.open(url.startsWith('http') ? url : `http://${url}`, '_blank');
        if (event) {
          const { parentElement } = event.target;
          // Remove selected class
          setTimeout(() => {
            parentElement.classList.remove('show');
          });
        }
      }
    },
    // Retrieving Notice List
    async getNoticeList() {
      await axios
        .get(`${SDLUtil.API_URL}/notice-popup-posts`)
        .then(({ data }) => {
          this.noticeList = data;
        })
        .catch(err => {
          SDLUtil.errorAlert(err);
        });
    },
    // Show notice popup When not checked notice is existing
    showNotCheckedNotice() {
      const firstNotCheckedNotice = _.find(this.noticeList, { noticeChecked: false });
      if (!_.isEmpty(firstNotCheckedNotice)) this.toggleNoticeArea(firstNotCheckedNotice);
    },
    // View Notice Details
    selectNotice(notice) {
      if (!notice.noticeChecked) {
        const params = { postId: notice.postId, userId: SDLUtil.getLoginedUserInfo().userId };
        SDLUtil.showLoadingBar(true);
        this.selectedNotice = notice;
        axios
          .post(`${SDLUtil.API_URL}/check-notice?${StringUtil.queryStringfy(params)}`)
          .then(() => {
            this.getNoticeList();
          })
          .catch(err => {
            SDLUtil.showLoadingBar(false);
            SDLUtil.errorAlert(err);
          });
        SDLUtil.showLoadingBar(false);
      } else {
        this.selectedNotice = notice;
      }
      if (this.selectedNotice.imageAttachExistsYn) this.getPostInfo();
      else this.imageAttachments = [];
    },
    /**
     * param:
     * return:
     * exception:
     * description : Retrieving Post Information
     */
    async getPostInfo() {
      SDLUtil.showLoadingBar(true);
      await axios
        .get(`${SDLUtil.API_URL}/boards/notice/posts/${this.selectedNotice.postId}`)
        .then(({ data }) => {
          this.imageAttachments = data.imageAttachments;
          // Image board > Load image attachment
          if (!_.isEmpty(this.imageAttachments)) {
            this.imageAttachments.map(async image => {
              SDLUtil.showLoadingBar(true);
              await this.getImageContent(image).then(blob => {
                this.$refs[image.fileId][0].src = window.URL.createObjectURL(blob);
              });
              SDLUtil.showLoadingBar(false);
            });
          }
        })
        .catch(err => {
          SDLUtil.showLoadingBar(false);
          SDLUtil.errorAlert(err);
        });
      SDLUtil.showLoadingBar(false);
    },
    /**
     * param: image -> Object
     * return:
     * exception:
     * description : Image attachment load
     */
    getImageContent(image) {
      return new Promise((resolve, reject) => {
        axios({
          url: `${SDLUtil.API_URL}/resource/attachments/file-download/${image.fileId}?downloadType=${image.downloadType}`,
          responseType: 'arraybuffer',
          method: 'get',
        })
          .then(response => {
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            return resolve(blob);
          })
          .catch(error => reject(error.message));
      });
    },
    // Notice area show / hide
    toggleNoticeArea(notice = null) {
      if (!_.isEmpty(this.offsider)) this.offsider = '';
      this.showNoticeArea = !this.showNoticeArea;
      if (this.showNoticeArea && !_.isEmpty(this.noticeList)) {
        if (_.isEmpty(notice)) this.selectNotice(_.first(this.noticeList));
        else this.selectNotice(notice);
      }
      if (!this.showNoticeArea) {
        this.selectedNotice = {};
        this.imageAttachments = [];
      }
    },
    overGnbMenuDepth() {
      this.rootMenus.forEach(menu => {
        document.getElementById(menu.menuId).classList.remove('active');
      });
    },
    outGnbMenuDepth() {
      if (this.clickedMenuId !== '') {
        this.rootMenus.forEach(menu => {
          if (menu.menuId === this.clickedMenuId && this.fixTop === true) document.getElementById(menu.menuId).classList.add('active');
          else document.getElementById(menu.menuId).classList.remove('active');
        });
      }
    },
    toggleGnbMenuDepth(menuId) {
      this.rootMenus.forEach(menu => {
        if (menu.menuId === menuId) {
          const { classList } = document.getElementById(menu.menuId);
          if (this.fixTop) {
            this.$emit('toggleFixTop', false);
            this.clickedMenuId = '';
            classList.remove('active');
          } else {
            this.$emit('toggleFixTop', true);
            this.clickedMenuId = menuId;
            classList.add('active');
          }
        } else document.getElementById(menu.menuId).classList.remove('active');
      });
    },
    async getDivisionCodeList() {
      await this.$store.dispatch('USER_DIV_INFO', {}).then(() => {
        this.divisionCodeList = this.divisionInfo;
      });
    },
    // from 우측 사이드바 시작
    ...mapActions(['logout', 'setLocale', 'setGMT', 'getMenus']),
    init() {
      this.offsider = '';
      this.searchQuickMenu = '';
      document.querySelector('body').classList.remove('overflow-hidden');
    },
    changeOffsider(menu) {
      if (this.showNoticeArea) this.showNoticeArea = false;
      this.offsider = this.offsider === menu ? '' : menu;
      // Remove scrolling to body if full size area
      const withoutScrollMenus = ['sitemap'];
      if (!withoutScrollMenus.includes(this.offsider)) {
        document.querySelector('body').classList.remove('overflow-hidden');
      } else {
        document.querySelector('body').classList.add('overflow-hidden');
      }
      // time zone area call
      if (this.offsider === 'user') {
        axios.get(`${SDLUtil.API_URL}/auth/users/timezone`).then(({ data }) => {
          this.timeZoneList = data.timeZoneList.map(zone => ({
            ...zone,
            // isEtc,
            timeZoneArea: zone.timeZoneId.split('/')[0],
          }));
          this.timeZoneArea = data.timeZoneArea;
          this.timeZoneId = data.timeZoneId;
        });
      }
      if (this.offsider === 'quick') {
        this.getUserQuickMenus();
      }
      if (this.offsider === 'division') {
        this.initDivision();
      }
    },
    openUserManual() {
      window.open(`${this.$context}/manual`, '_blank');
    },
    goLoginPage() {
      this.$router.push(`${this.$context}/logout`);
    },
    getRootMenus(idx) {
      const result = [];
      for (let i = idx * 4, nMax = idx * 4 + 4; i < nMax; i += 1) {
        if (this.rootMenus[i] === undefined) {
          break;
        }
        result.push(this.rootMenus[i]);
      }
      return result;
    },
    // getSubmenu(parentId) {
    //   return _.sortBy(this.menus.filter(menu => menu.parentId === parentId), ['menuSequence']);
    // },
    getUserQuickMenus() {
      // quick 메뉴 전체, All quick menu
      // 외부 링크 사용 혹은 default Page 가 있는 메뉴
      this.quickMenus = this.menus
        .filter(menu => {
          // 외부 링크 사용
          if (menu.externalUrlUsed) {
            return true;
          }
          const superParentMenu = this.getSuperParentMenu(menu);
          // default Page 가 있는 메뉴
          return menu.pages.length > 0
            && _.find(menu.pages, ['defaulted', true])
            && menu.parentId !== 'COMM_URL'
            && superParentMenu !== undefined
            && superParentMenu.menuId !== 'AYkfdJPWABJ6D2HP';
        })
        .map(menu => {
          const defaultPage = _.find(menu.pages, ['defaulted', true]);
          return {
            ...menu,
            ...defaultPage,
            selected: false,
          };
        });

      axios.get(`${SDLUtil.API_URL}/auth/quick-menus`).then(({ data }) => {
        this.userMenus = [];
        data.forEach(menuId => {
          const menu = _.find(this.quickMenus, ['menuId', menuId]);
          if (menu) {
            menu.selected = true;
            this.userMenus.push(menu);
          }
        });
      });
    },
    changeLocale(locale) {
      this.$i18n.locale = locale;
      this.setLocale(locale);
      this.updateUserToken({ language: locale });
      // this.changeOffsider('language');
    },
    getLocaleLabel(locale) {
      return this.$i18n.getLocaleMessage(locale)['sdl.common.language.label'];
    },
    removeQuickMenu(menuId, index) {
      axios.delete(`${SDLUtil.API_URL}/auth/quick-menus/${menuId}`).then(() => {
        this.userMenus.splice(index, 1);
        this.$store.commit('SET_USER_MENUS_BREAD_CRUMB', this.userMenus);
        // default quick Menu add
        const menu = _.find(this.quickMenus, ['menuId', menuId]);
        if (menu) {
          menu.selected = false;
        }
      });
    },
    addQuickMenu(menu) {
      if (menu.selected) return;
      menu.selected = true;
      SDLUtil.showLoadingBar(true);
      this.userMenus = [...this.userMenus, menu];
      this.$store.commit('SET_USER_MENUS_BREAD_CRUMB', this.userMenus);
      this.saveQuickMenu()
        .then(() => {
          // console.info('success', data);
          SDLUtil.showLoadingBar(false);
        })
        .catch(err => {
          SDLUtil.showLoadingBar(false);
          SDLUtil.errorAlert(err);
          this.userMenus.pop();
          this.$store.commit('SET_USER_MENUS_BREAD_CRUMB', this.userMenus);
        });
    },
    saveQuickMenu() {
      // console.info('params', this.userMenus.map(menu => menu.menuId));
      return axios.post(`${SDLUtil.API_URL}/auth/quick-menus`, this.userMenus.map(menu => menu.menuId));
    },
    moveMenuList(event) {
      if (event.moved) {
        // api call
        this.saveQuickMenu();
      }
    },
    saveTimezone() {
      SDLUtil.showLoadingBar(true);
      axios
        .put(`${SDLUtil.API_URL}/auth/users/timezone?${StringUtil.queryStringfy({ timeZoneId: this.timeZoneId })}`)
        .then(({ data }) => {
          SDLUtil.showLoadingBar(false);
          this.updateUserToken({ timeZoneId: this.timeZoneId, timeZoneCode: data });
        })
        .catch(err => {
          SDLUtil.errorAlert(err);
          SDLUtil.showLoadingBar(false);
        });
    },
    // moveMenu(pagePath) {
    //   // Initialize saved parameters when forced to move from the menu
    //   store.commit('PARAMS', {});
    //   this.$router.push({ path: pagePath });
    //   // If the moving component is the same, refresh is required
    //   const fromComponentName = this.$route.meta.componentName;
    //   const toMenu = _.find(this.menus, ['menuUrl', pagePath]);
    //   if (fromComponentName === toMenu.componentName) {
    //     this.$emit('router-reload');
    //   }
    // },
    updateUserToken(param) {
      const params = {
        language: this.userInfo.language,
        timeZoneId: this.userInfo.timeZoneId,
        timeZoneCode: this.userInfo.timeZoneCode,
        ...param,
      };

      axios.put(`${SDLUtil.API_URL}/auth/users/user-token`, params).then(({ data }) => {
        loginService.setRefreshToken(data.jwtToken);
        this.userInfo = SDLUtil.getLoginedUserInfo();
      });
    },
    // openExternalUrl(url) {
    //   window.open(url.startsWith('http') ? url : `http://${url}`, '_blank');
    // },
    changePasswordPopup() {
      SDLUtil.show(ChangePasswordPopup, null, {
        // width: '600',
        // height: '400',
        // 가로사이즈 : big, large, medium, small, mini
        // 세로사이즈고정 : h_fix
        sizeClass: 'small',
      });
    },
    entrustApprovalPopup() {
      SDLUtil.show(EntrustApprovalPopup, null, {
        // width: '600',
        // height: 'auto',
        // 가로사이즈 : big, large, medium, small, mini
        // 세로사이즈고정 : h_fix
        sizeClass: 'small',
      });
    },
    /**
     * Open Trans Popup
     */
    openTrans() {
      const width = 1100;
      const height = 670;
      const leftPosition = Math.ceil((window.screen.width - width) / 2);
      const topPosition = Math.ceil((window.screen.height - height) / 2);

      window.open(
        `${SDLUtil.WEB_CONTEXT_PATH}/transPopup`,
        'popup',
        `width=${width},height=${height},top=${topPosition},left=${leftPosition},location=0,directories=0,resizable=0,status=0,toolbar=0,menubar=0`,
        '_blank',
      );
    },
    // from 우측 사이드바 끝
    getUserDivisionInfo() {
      const param = SDLUtil.getLoginedUserInfo();
      this.$store.dispatch('SEARCH_USER_DIV_INFO', param);
    },
    getUserDivisionList() {
      const param = { userId: SDLUtil.getLoginedUserInfo().userId };
      this.$store.dispatch('SEARCH_USER_DIV', param);
    },
    changeUserDivision(divisionCode) {
      if (_.isEmpty(divisionCode)) return;
      const param = {
        userId: SDLUtil.getLoginedUserInfo().userId,
        divisionCd: divisionCode,
      };
      this.$store.dispatch('UPDATE_USER_DIV', param).then(() => {
        window.location.href = `${this.$context}/`;
      });
    },
    changeAdminUserDivision(divisionCode) {
      if (_.isEmpty(divisionCode)) return;
      const param = {
        userId: SDLUtil.getLoginedUserInfo().userId,
        divisionCd: divisionCode,
      };
      this.$store.dispatch('UPDATE_ADMIN_USER_DIV', param).then(() => {
        window.location.href = `${this.$context}/`;
      });
    },
    closeNotice(event) {
      if (this.isClickOutsideExcludeElement(event.evt.target)) return;
      if (!event.evt.target.classList.contains('notice_popup_alarm') && this.showNoticeArea) this.showNoticeArea = false;
    },
    closeUser(event) {
      if (event.evt.target.className !== 'fnc_user' && this.offsider === 'user') this.offsider = '';
    },
    closeBookmark(event) {
      if (event.evt.target.className !== 'fnc_bookmark' && this.offsider === 'quick') this.offsider = '';
    },
    closeDivision(event) {
      if (!event.evt.target.classList.contains('fnc_division') && this.offsider === 'division') this.offsider = '';
    },
    isClickOutsideExcludeElement(element) {
      const hasIntersection = (baseList, compareList) => _.intersection(baseList, compareList).length > 0;

      const parent = element.parentElement;
      if (element) {
        if (hasIntersection(this.clickOutsideExcludeElements, element.classList)) return true;
      }
      if (parent) {
        if (hasIntersection(this.clickOutsideExcludeElements, parent.classList)) return true;
        return this.isClickOutsideExcludeElement(parent);
      }
      return false;
    },
    initClickOutsideExcludeElements() {
      const onBoardingClassList = this.$refs.onBoarding.$el.classList;
      _.forEach(onBoardingClassList, item => this.clickOutsideExcludeElements.push(item));
    },
    setCurrentMenuStyle(rootMenu) {
      if (this.$route.path === this.mainPath) return false;
      return rootMenu.menuId === this.superParentMenu.menuId;
    },
    getCurrentRoleList() {
      const params = { userId: this.userInfo.userId };
      this.$store.dispatch('SEARCH_ROLE_DIV', params);
    },
    /**
     * param: nothing
     * return: nothing
     * exception: nothing
     * description: Division select box 선택 시 Division 필터링
     */
    onChangeDomestic() {
      this.divRhq = '';
      this.gbmSub = '';
      this.divRhqList = _.filter(this.divisionInfo, this.setParams('GBMGroup'));
      this.gbmSubList = _.filter(this.divisionInfo, this.setParams('GBM'));
    },
    onChangeGbM() {
      this.gbmSubList = _.filter(this.divisionInfo, this.setParams('GBM'));
      this.gbmSub = '';
    },
    /**
     * param: gbm
     * return: nothing
     * exception: nothing
     * description: Division select box 선택 시 Division 필터링
     */
    setParams(gbm) {
      let params = { groupType: gbm };
      if (this.domesticInfo) {
        params = { ...params, domestic: this.domesticInfo };
      }
      if (this.divRhq) {
        params = { ...params, parentDivisionCd: this.divRhq };
      }
      return params;
    },
    initDivision() {
      const selectedDivision = _.find(this.divisionCodeList, { divisionCd: this.userDivisionInfo.divisionCode });
      if (_.isEmpty(selectedDivision)) return;
      this.domesticInfo = selectedDivision.domestic;
      this.onChangeDomestic();
      this.divRhq = selectedDivision.parentDivisionCd;
      this.onChangeGbM();
      this.gbmSub = selectedDivision.divisionCd;
    },
  },
  created() {
    // document.querySelector('body').classList.remove('sdl-wrap', 'ui--login-wrap');
    if (document.querySelector('body').classList.contains('ui--login-wrap')) {
      document.querySelector('body').classList.remove('ui--login-wrap');
    }
    if (document.querySelector('body').classList.contains('sdl-wrap')) {
      document.querySelector('body').classList.remove('sdl-wrap');
    }
    this.getNoticeList().then(() => { this.showNotCheckedNotice(); });
    this.userInfo = SDLUtil.getLoginedUserInfo();
    this.getUserDivisionList();
    this.getUserDivisionInfo();
    this.getDivisionCodeList();
    this.getCurrentRoleList();

    this.$eventBus.$on('showOnBoarding', (options) => {
      this.$refs.onBoarding.onBoardingShow = true;
      this.$refs.onBoarding.hideDontShowAgain = !!(options && options.hideDontShowAgain);
    });
  },
  mounted() {
    this.$nextTick(() => {
      // resize event
      window.onresize = _.debounce(() => {
        this.setSubMenuStyle();
      }, 100);

      // ref. https://getbootstrap.com/docs/4.0/components/dropdowns/#events
      $('li.nav-item.dropdown').on('show.bs.dropdown', () => {
        this.setSubMenuStyle();
      });

      this.initClickOutsideExcludeElements();
    });
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/admin/main/MainTopMenu.vue